import React from 'react';
import { COLORS, FlexView, Separator } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import { CopyButton } from 'comps';

export default function MoreIds({
  parentId,
  parentServiceId,
  primaryTeacherId,
  studentId,
  studentServiceId,
}) {
  const idsMap = [
    {
      name: 'Student ID',
      id: studentId,
    },
    {
      name: 'Student service ID',
      id: studentServiceId,
    },
    {
      name: 'Parent ID',
      id: parentId,
    },
    {
      name: 'Parent service ID',
      id: parentServiceId,
    },
    {
      name: 'Teacher ID',
      id: primaryTeacherId,
    },
  ];

  return (
    <FlexView>
      {idsMap?.map(({ name, id }) => (
        <div key={name}>
          <Text variant="eyebrow2" color={COLORS.COLA_LIGHTER}>
            {name} {!id && '-'}
          </Text>
          {id && (
            <>
              <Separator transparent height={8} />
              <CopyButton copyMessage={`Copy ${name}`} text={id} />
            </>
          )}
          <Separator transparent height={16} />
        </div>
      ))}
    </FlexView>
  );
}
